import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../../../components/Dialog";
import { CloseArenaDialog } from "../../../redux/arena-dialog/action";
import ArenaDashboardOriginal from "../../../game-engine/components/dashboard";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const ArenaDashboard: React.FC = () => {
  const dispatch = useDispatch();
  const arenaDialog = useSelector((state: any) => state.arenaDialog);
  const { t } = useAppTranslation("battle");
  if(!arenaDialog?.open) return "";
  return (
    <Dialog
      title={t("labels.arena")}
      open={true}
      size="xl"
      backdropClose
      noFooter
      onClose={() => dispatch(CloseArenaDialog())}
    >
      <ArenaDashboardOriginal />
    </Dialog>
  );
};

export default ArenaDashboard; 
